<style lang="less">
@import '../styles/menu.less';
</style>
<template>
  <Scroll :height="680">
    <Menu ref="sideMenu" :active-name="openNameRoute" :open-names="menuList" :accordion="true" :theme="menuTheme"
      width="auto" @on-select="changeMenu" @on-open-change="onOpenChange">
      <template v-for="item in menuList">
        <!--            <template v-if="item.name === 'blank'"> &lt;!&ndash; 空白条 &ndash;&gt;-->
        <template v-if="item.status == false">
          <MenuItem v-if="(item.show != false)" :name="item.children[0].name" :key="'menuitem' + item.name"
            style="padding-top:2px;padding-bottom:2px;width: 180px;height: 49px;">
          <div style="margin-top: 14px">
            <Icon type="ios-menu-outline" :size="iconSize" :key="'menuicon' + item.name" style="margin-right: 6px"></Icon>
            <span class="layout-text" :key="'title' + item.name">{{ itemTitle(item) }}</span>
          </div>
          </MenuItem>
        </template>
        <template v-if="item.status == true">
          <!-- <MenuGroup v-if="(item.children.length >= 1) && (item.style !== 'box')" :name="item.name" :key="item.name"> -->
          <template v-if="(item.children.length >= 1) && (item.style !== 'box')">
            <!-- <template slot="title">
              <Icon :type="item.icon" :size="iconSize"></Icon>
              <span class="layout-text">{{ itemTitle(item) }}</span>
            </template> -->
            <template v-for="child in item.children">
              <template v-if="(child.show != false) && (child.status == false)">
                <MenuItem :name="child.name" :key="'menuitem' + child.name">
                <Icon type="ios-menu-outline" :size="iconSize" :key="'icon' + child.name"></Icon>
                <span class="layout-text" :key="'title' + child.name">{{ itemTitle(child) }}</span>
                </MenuItem>
              </template>

              <template
                v-if="(child.show != false) && (child.children != null) && child.children.length > 0 && (child.status == true)">
                <MenuGroup :name="child.children" :key="child.children">
                  <!-- <MenuGroup :name="child.children" @on-click="onOpenChange"> -->
                  <!-- <template slot="title">
                    <Icon :type="child.icon" :size="iconSize" :key="'icon' + child.name"></Icon>
                    <span class="layout-text" :key="'title' + child.name" style="padding-left: -5px;height: 49px">{{
                      itemTitle(child)
                    }}</span>
                  </template> -->
                  <template v-for="(c) in child.children">
                    <MenuItem :name="c.name" :key="'menuitem' + c.name">
                    <Icon type="ios-menu-outline" :size="iconSize" :key="'icon' + c.name"></Icon>
                    <span class="layout-text" :key="'title' + c.name">{{ itemTitle(c) }}</span>
                    </MenuItem>
                  </template>
                </MenuGroup>
              </template>
            </template>
            <!-- </MenuGroup> -->
          </template>
        </template>
      </template>
    </Menu>
  </Scroll>
</template>

<script>
let customerId = window.localStorage.getItem("customerId")
export default {
  name: 'sidebarMenu',
  props: {
    menuList: Array,
    iconSize: {
      type: Number,
      default: 18
    },
    menuTheme: {
      type: String,
      default: 'dark'
    },
    openNames: {
      type: Array
    }
  },
  created() {
    console.log(this.$route.name, this.$route, '-------------,1111111');

  },
  computed: {
    // openMemus () {
    //     // 遍历路由判断是否有一直需要打开的目录
    //     // for (const m in this.menuList) {
    //     //     let item = this.menuList[m]
    //     //     if(item.openmenu){
    //     //         this.openNames.push(item.name)
    //     //     }
    //     // }
    //     // return this.openNames
    // }
    openNameRoute() {
      let str = this.$route.path
      const firstIndex = str.indexOf('/');
      const secondIndex = str.indexOf('/', firstIndex + 1);
      let b = ""
      if (secondIndex != "-1") {
        b = str.slice(firstIndex + 1, secondIndex)
      } else {
        b = str.slice(firstIndex + 1)
      }
      return b
    }
  },
  methods: {
    changeMenu(active) {
      let menu = this.menuList;
      let menuI = this.queckChildMenu(menu, active)
      try {
        if (active === "facilityTracking1" && Number(customerId) !== 122) {
          return
          // window.location.href = menu.children[0].url
        }
        if (active === "facilityTracking1" && Number(customerId) === 122) {
          window.open(menu[menuI.i].children[0].url, '_blank')
          // window.location.href = menu.children[0].url
        } if (active === "facilityTracking2" && Number(customerId) !== 122) {
          return
          // window.location.href = menu.children[0].url
        }
        if (active === "facilityTracking2" && Number(customerId) === 122) {
          window.open(menu[menuI.i].children[0].url, '_blank')
          // window.location.href = menu.children[0].url
        } if (active === "facilityTracking3" && Number(customerId) !== 122) {
          return
          // window.location.href = menu.children[0].url
        }
        if (active === "facilityTracking3" && Number(customerId) === 122) {
          window.open(menu[menuI.i].children[0].url, '_blank')
          // window.location.href = menu.children[0].url
        } if (active === "facilityTracking4" && Number(customerId) !== 122) {
          return
          // window.location.href = menu.children[0].url
        }
        if (active === "facilityTracking4" && Number(customerId) === 122) {
          window.open(menu[menuI.i].children[0].url, '_blank')
          // window.location.href = menu.children[0].url
        }
        if (active === "workOrder") {
          active = menu[menuI.i].children[menuI.j].children[0].children[0].name
        } else if (menu[menuI.i].children[menuI.j] && menu[menuI.i].children[menuI.j].children !== undefined) {
          active = menu[menuI.i].children[menuI.j].children[0].name
        }
      } catch (e) {
        console.log(e)
      }
      this.$emit('on-change', active);
    },
    onOpenChange(e) {
      setTimeout(() => {
        let menu = this.menuList;
        menu = this.queckMenu(menu, e[0])
        if (menu && menu.children && menu.children[0] && menu.children[0].children === undefined) {

          if (Number(customerId) === 122) {
            if (menu.children[0].name === "facilityTracking1" ||
              menu.children[0].name === "facilityTracking2" ||
              menu.children[0].name === "facilityTracking3" ||
              menu.children[0].name === "facilityTracking4") {
              window.open(menu.children[0].url, '_blank')
            } else {
              this.$router.push({
                name: menu.children[0].name
              });
            }
            // window.location.href = menu.children[0].url
          } else {
            this.$router.push({
              name: menu.children[0].name
            });
          }
        } else {
          menu = menu ? menu.children[0] : false
          if (menu && menu.children[0].children === undefined) {
            if (Number(customerId) === 122) {
              if (menu.children[0].name === "facilityTracking1" ||
                menu.children[0].name === "facilityTracking2" ||
                menu.children[0].name === "facilityTracking3" ||
                menu.children[0].name === "facilityTracking4") {
                window.open(menu.children[0].url, '_blank')
              } else {
                this.$router.push({
                  name: menu.children[0].name
                });
              }
            } else {
              this.$router.push({
                name: menu.children[0].name
              });
            }
          }
        }
      }, 300);


    },
    queckMenu(menu, e) {
      for (let i = 0; i < menu.length; i++) {
        if (menu[i].name === e) {
          return menu[i];
        } else {
          this.queckMenu(menu[i], e)
        }
      }
    },
    queckChildMenu(menu, e) {
      let arr = {}
      for (let i = 0; i < menu.length; i++) {
        for (let j = 0; j < menu[i].children.length; j++) {
          if (menu[i].children[j].name === e) {
            return arr = { i, j };
          }
        }
      }
    },
    itemTitle(item) {
      if (typeof item.title === 'object') {
        return this.$t(item.title.i18n);
      } else {
        return item.title;
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.sideMenu) {
        this.$refs.sideMenu.updateOpened();
      }
    });
  }

};
</script>
<style lang="less" scoped>
.box-sub-item {
  width: 50%;
  float: left;
  padding-left: 12% !important;

  .layout-text {
    margin-left: 0px;
  }
}

.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active,
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active:hover {
  border-right: none;
  color: #2d8cf0 !important;
  background: none !important;
}

.ivu-menu .ivu-menu-submenu .ivu-menu-submenu-title {
  height: 49px !important;
}

.ivu-menu .ivu-menu-submenu .ivu-menu-submenu-title {
  height: 49px !important;
}
</style>
